:host {
  display: flex;
  justify-self: center;
  align-self: center;
}
